import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import ModalFixed from "../../components/ModalFixed";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import Notification from "../../components/Notification";

import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";

import { PosgradoPostulacionFixed } from "../../components/Pasos";
import Modal from "../../components/Modal";
import OfferPosgrados from "../../components/view/OfferPosgrados";

function Posgrados() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="relative">
              <Notification
                content={
                  <>
                    <PosgradoPostulacionFixed></PosgradoPostulacionFixed>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.bloque1,
                      }}
                    />

                    <Modal
                      title="🔍 Conoce el proceso de postulación y matrícula"
                      content={
                        <>
                          <div>
                            <iframe
                              width="100%"
                              height="449"
                              src="https://www.youtube.com/embed/rL-8vTAn8P0"
                              title="Posgrados UTPL | Admisión y matrícula paso a paso"
                              frameborder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              referrerpolicy="strict-origin-when-cross-origin"
                              allowfullscreen
                            ></iframe>
                          </div>
                        </>
                      }
                    ></Modal>
                  </>
                }
              ></Notification>
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/posgrados">Posgrados</NavLink>
                </>
              }
            ></Breadcumbs>
            <div
              className="layout8"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque2,
              }}
            />
            <div>
              <OfferPosgrados></OfferPosgrados>
            </div>
            {/*     <div className="padding">
              <PosgradoPagos></PosgradoPagos>
            </div> */}
            <div className="margin">
              <BlockBackgroundImage
                src={item.field_imagen4}
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque4,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-posgrados-new.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <ConectUs
        facebook="https://www.facebook.com/utpltec/"
        instagram="https://www.instagram.com/utpltec/"
        tiktok="https://www.tiktok.com/@utpltec"
        x="https://twitter.com/utpl?lang=es"
        youtube="https://www.youtube.com/user/utpl/"
        linkedin="https://www.linkedin.com/company/utpl-tec/"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Posgrados;
